<app-menu></app-menu>
<div class="container-fluid∂ mt-5">
    <div class="col-12">
        <div class="row">
            <div class="col-6">
                <h3>
                    <img src="../../../assets/img/registro.png" width="70"> Solicitudes para Distribuidor:
                </h3>
            </div>
        </div>
    </div>
    <hr>
    <div class="mt-2">
        <div class="table-responsive">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Cédula</th>
                        <th scope="col">Email</th>
                        <th scope="col">Fecha Registro</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of lista">
                        <th>{{item.nombre}}</th>
                        <td>{{item.cedula}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.fechaCreacion | date}}</td>
                        <td>
                            <a title="Ver Rut" class="btn btn-primary" [href]="item.rut" target="_Blank"><i class="fa fa-download"></i></a>
                            <button class="btn btn-success ml-1" title="Aceptar nuevo distribuidor" (click)="aceptarDistribuidor(item.id)"><i class="fa fa-check"></i></button>
                            <button class="btn btn-danger ml-1" title="Eliminar Solicitud" (click)="eliminarDistribuidor(item.id)"><i class="fa fa-trash"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>